import {GET_ANIMALS_RECOMENDATION, GET_SIMILAR_ENTITIES} from "../actions/actionsRecomendations";

const initialState = {
    list: [],
};

export function reducerRecomendations(state = initialState, action) {
    
    switch (action.type) {
        case GET_ANIMALS_RECOMENDATION:
            return Object.assign({}, state, {
                list: action.payload.result,
                totalRecords:action.payload.totalRecords
            });
        
        case GET_SIMILAR_ENTITIES:
            return Object.assign({}, state, {
                entities:{
                    similar:action.payload.result
                },
            });
        
        
        default:
            return state
    }
}